import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-flashlight-fill',
      title: t('services.fastTrack.title'),
      description: t('services.fastTrack.description'),
      features: [
        t('services.fastTrack.feature1'),
        t('services.fastTrack.feature2'),
        t('services.fastTrack.feature3')
      ],
      gradient: 'from-[#FF6B6B] to-[#FF8E53]',
      image: 'https://public.readdy.ai/ai/img_res/4386ba9e17e5821a9964c6a9537bb37f.jpg'
    },
    {
      icon: 'ri-shield-check-fill',
      title: t('services.claims.title'),
      description: t('services.claims.description'),
      features: [
        t('services.claims.feature1'),
        t('services.claims.feature2'),
        t('services.claims.feature3')
      ],
      gradient: 'from-[#4ECDC4] to-[#44A08D]',
      image: 'https://readdy.ai/api/search-image?query=Professional%20customer%20service%20representative%20with%20tablet%20managing%20luggage%20claims%20in%20modern%20airline%20office%2C%20turquoise%20and%20coral%20accents%2C%20organized%20workspace%20with%20damaged%20suitcases%20being%20documented%2C%20friendly%20atmosphere%2C%20contemporary%20business%20environment&width=500&height=350&seq=service-claims-001&orientation=landscape'
    },
    {
      icon: 'ri-truck-fill',
      title: t('services.logistics.title'),
      description: t('services.logistics.description'),
      features: [
        t('services.logistics.feature1'),
        t('services.logistics.feature2'),
        t('services.logistics.feature3')
      ],
      gradient: 'from-[#A855F7] to-[#9333EA]',
      image: 'https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/f04326bd0578a8c0dd5d47619f781098.jpeg'
    },
  ];

  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF6B6B]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#4ECDC4]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-[#FF6B6B]/10 rounded-full text-[#FF6B6B] text-xs sm:text-sm font-semibold mb-4">
            <i className="ri-service-fill"></i>
            {t('services.badge')}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t('services.title')}
            <br />
            <span className="bg-gradient-to-r from-[#FF6B6B] to-[#4ECDC4] bg-clip-text text-transparent">
              {t('services.titleHighlight')}
            </span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto px-4">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              {/* Service Image */}
              <div className="relative h-40 sm:h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${service.gradient} opacity-20 group-hover:opacity-30 transition-opacity`}></div>
                
                {/* Floating Icon */}
                <div className={`absolute top-3 sm:top-4 right-3 sm:right-4 w-12 sm:w-14 h-12 sm:h-14 bg-gradient-to-br ${service.gradient} rounded-2xl flex items-center justify-center shadow-lg`}>
                  <i className={`${service.icon} text-white text-xl sm:text-2xl`}></i>
                </div>
              </div>

              {/* Service Content */}
              <div className="p-5 sm:p-6">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#FF6B6B] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {service.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <div className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <div className={`w-5 sm:w-6 h-5 sm:h-6 bg-gradient-to-br ${service.gradient} rounded-lg flex items-center justify-center flex-shrink-0`}>
                        <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                      </div>
                      <span className="text-gray-700 text-xs sm:text-sm font-medium">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
